import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ViewContainerRef,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { Observable } from 'rxjs';
import { ComponentStyle, StylingMode } from '../abcComponent.model';
import { AbcComponentService } from '../abcComponent.service';
import {
  IDocumentInput,
  DocumentInputStyle,
  DocumentInputButton,
  StylinMode,
  ModeDocumentationInput,
} from './abcDocumentInput';
import { DevExDocumentInputComponent } from '../../../devExtreme/src/devExDocumentInput/devExDocumentInput.component';

@Component({
    selector: 'abcDocumentInput',
    template: '<ng-template #abcDocumentInput></ng-template>',
    standalone: false
})
export class AbcDocumentInputComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input('id') attrId: string;
  @Input('buttonList') attrButtonList: DocumentInputButton[];
  @Output() onChange = new EventEmitter();
  @ViewChild('abcDocumentInput', { static: true, read: ViewContainerRef }) viewContainerRef: ViewContainerRef;
  @Input() style: ComponentStyle = ComponentStyle.DevExpress;
  htmlAttributes: IDocumentInput;
  eventListener = [];
  private componentRef;
  private _height: string | number = 25;
  private _width: string;
  private _visible: boolean;
  private _placeholder: string;
  private _value: any;
  private _disabled: boolean;
  private _mode: ModeDocumentationInput;
  private _rtlEnabled: boolean;
  private _stylingMode: StylingMode;
  private _class: string;

  get id(): string {
    return this.componentRef.id;
  }
  set _id(value: any) {
    this.componentRef.value = value;
  }

  @Input()
  get height() {
    return this._height;
  }
  set height(data) {
    if (this.componentRef) {
      this.componentRef.height = data;
    }
    this._height = data;
  }

  @Input()
  get mode() {
    return this._mode;
  }
  set mode(data) {
    if (this.componentRef) {
      this.componentRef.mode = data;
    }
    this._mode = data;
  }

  @Input()
  get value() {
    return this._value;
  }
  set value(data) {
    if (this.componentRef) {
      this.componentRef.value = data;
    }
    this._value = data;
  }

  @Input()
  get class() {
    return this._class;
  }
  set class(data) {
    if (this.componentRef) {
      this.componentRef.class = data;
    }
    this._class = data;
  }

  @Input()
  get disabled() {
    return this._disabled;
  }
  set disabled(data) {
    if (this.componentRef) {
      this.componentRef.disabled = data;
    }
    this._disabled = data;
  }

  @Input()
  get rtlEnabled() {
    return this._rtlEnabled;
  }
  set rtlEnabled(data) {
    if (this.componentRef) {
      this.componentRef.rtlEnabled = data;
    }
    this._rtlEnabled = data;
  }

  @Input()
  get width() {
    return this._width;
  }
  set width(data) {
    if (this.componentRef) {
      this.componentRef.width = data;
    }
    this._width = data;
  }

  @Input()
  get placeholder() {
    return this._placeholder;
  }
  set placeholder(data) {
    if (this.componentRef) {
      this.componentRef.placeholder = data;
    }
    this._placeholder = data;
  }

  @Input()
  get visible() {
    return this._visible;
  }
  set visible(data) {
    if (this.componentRef) {
      this.componentRef.visible = data;
    }
    this._visible = data;
  }

  @Input()
  get stylingMode() {
    return this._stylingMode;
  }
  set stylingMode(data) {
    if (this.componentRef) {
      this.componentRef.stylingMode = data;
    }
    this._stylingMode = data;
  }

  constructor(private abcComponentService: AbcComponentService) {
    this.style = ComponentStyle.DevExpress;
    this._stylingMode = this.abcComponentService.stylingMode;
  }

  ngOnInit() {
    this.setDocumentInputAttributesIfAvailable();
    this.createComponentInstance().subscribe((component) => {
      this.eventListener.forEach((element) => {
        component.addEventListener(element.type, element.listener);
      });
    });
  }

  ngAfterViewInit() {
    this.abcComponentService.addInstance(this);
  }

  ngOnDestroy(): void {
    this.eventListener = [];
    this.abcComponentService.removeInstance(this);
  }

  createComponentInstance(): Observable<any> {
    const observable = new Observable((observer) => {
      switch (this.style) {
        case ComponentStyle.DevExpress: {
          this.componentRef = this.abcComponentService.loadComponent(
            DevExDocumentInputComponent,
            this.viewContainerRef
          ).componentRef.instance;
          this.componentRef.onChange.subscribe((event) => {
            this.dataChange(event);
          });
          break;
        }
      }
      if (this.htmlAttributes.id) this.componentRef.id = this.htmlAttributes.id;
      if (this.htmlAttributes.placeholder) this.componentRef.placeholder = this.htmlAttributes.placeholder;
      if (this.htmlAttributes.value) this.componentRef.value = this.htmlAttributes.value;
      if (this.htmlAttributes.buttonList) this.componentRef.buttonList = this.htmlAttributes.buttonList;
      observer.next(this.componentRef);
    });

    return observable;
  }

  setDocumentInputAttributesIfAvailable() {
    if (this.attrId) {
      const style: DocumentInputStyle = {
        height: this.height ? this.height : 25,
        width: this.width ? this.width : '100%',
      };
      this.htmlAttributes = {
        id: this.attrId,
        placeholder: this.placeholder,
        value: this.value,
        visible: this.visible,
        disabled: this.disabled,
        rtlEnabled: this.rtlEnabled,
        class: this.class,
        buttonList: this.attrButtonList,
        setDocumentInputStyle: (_documentInputStyle) => (_documentInputStyle = style),
      };
    }
  }
  private dataChange(newValue) {
    this.onChange.emit({ newValue: newValue });
  }
}
